export default __webpack_public_path__ + "fonts/Nunito-Light.fa07c54b.woff2";